import Choices from 'choices.js';

module.exports = {
	xChoices: () => {
		return {
			init() {
				this.$nextTick(() => {
					let choices = new Choices(this.$refs.select, {
						searchEnabled: false,
						allowHTML: true,
						shouldSort: false,
						itemSelectText: this.$refs.select.dataset.text ? this.$refs.select.dataset.text : ''
					})
				})
			}
		}
	}
}